var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router-container"},[_vm._v(" 暂时无法直接使用路由，请用ifrane代替 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }